/**
 * Надёжный UUID v4 для клиентских id (комнаты, фото, idempotency-ключи и т.п.).
 *
 * `crypto.randomUUID()` есть НЕ везде: старый iOS Safari (<15.4), старые
 * Android WebView, небезопасный контекст (http). Раньше фолбэком был
 * `room-${Date.now()}` — такой id не проходил бэковую `@IsUUID()`-валидацию
 * (ошибка «id must be a UUID» при создании комнаты на старом телефоне).
 * Здесь всегда возвращаем валидный UUID v4, каскадом по доступности API:
 *   crypto.randomUUID → crypto.getRandomValues → Math.random (крайний случай).
 */
export function uuidv4(): string {
  const c: Crypto | undefined = globalThis.crypto;
  if (c?.randomUUID) return c.randomUUID();

  const b = new Uint8Array(16);
  if (c?.getRandomValues) {
    c.getRandomValues(b);
  } else {
    for (let i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256);
  }
  // Проставляем версию (4) и variant (10xx) по RFC 4122.
  b[6] = (b[6]! & 0x0f) | 0x40;
  b[8] = (b[8]! & 0x3f) | 0x80;

  const s = Array.from(b, (n) => n.toString(16).padStart(2, '0')).join('');
  return `${s.slice(0, 8)}-${s.slice(8, 12)}-${s.slice(12, 16)}-${s.slice(16, 20)}-${s.slice(20)}`;
}
